import React, { useEffect, useState } from "react";
import { getDemoTrackBlob, isWlDemoBlobRef, wlDemoBlobStorageKeyFromRef } from "../utils/demoTrackBlobStore";
import { resolveBrandingAssetUrl } from "../utils/brandingAssetUrl";
import { pickArtworkSrc } from "../utils/demoArtworkHelpers";

/** Resolves webpack paths, API-relative paths, and wl-demo IndexedDB blob refs for table thumbnails. */
const DemoArtworkThumb = ({ artwork, alt = "", size = 40, style = {} }) => {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    let cancelled = false;
    let objectUrl = null;
    const raw = pickArtworkSrc(artwork);

    if (!raw) {
      setSrc(null);
      return () => {};
    }

    if (isWlDemoBlobRef(raw)) {
      (async () => {
        try {
          const storageKey = wlDemoBlobStorageKeyFromRef(raw);
          const blob = await getDemoTrackBlob(storageKey);
          if (cancelled || !blob) {
            return;
          }
          objectUrl = URL.createObjectURL(blob);
          setSrc(objectUrl);
        } catch {
          if (!cancelled) {
            setSrc(null);
          }
        }
      })();
    } else {
      setSrc(resolveBrandingAssetUrl(raw) || raw);
    }

    return () => {
      cancelled = true;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [artwork]);

  if (!src) {
    return null;
  }

  return (
    <img
      style={{ width: size, height: size, borderRadius: "100%", ...style }}
      src={src}
      alt={alt}
    />
  );
};

export default DemoArtworkThumb;
